// Central app-wide constants.
// Single source of truth for the brand name and the super-admin identity so
// they can be changed in one place.

export const APP_NAME = "Hapi Foodstuffs";

// The account that is always granted super-admin (cannot be assigned via the UI).
export const SUPER_ADMIN_EMAIL = "ibiekay@gmail.com";

// User roles
export const ROLE_SUPER_ADMIN = "super_admin";
export const ROLE_SUB_ADMIN = "sub_admin";
export const ROLE_USER = "user";
